const LANGUAGE_KEY = 'LANGUAGE'

const storage = {
    clearAll: () => localStorage.clear(),
    setLanguage: (language) => localStorage.setItem(LANGUAGE_KEY, language),
    getLanguage: () => localStorage.getItem(LANGUAGE_KEY),
}

export default storage
